var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3734 10.3598C23.2801 10.3465 23.1867 10.3465 23.0934 10.3598C21.0267 10.2932 19.3867 8.59984 19.3867 6.51984C19.3867 4.39984 21.1067 2.6665 23.2401 2.6665C25.3601 2.6665 27.0934 4.3865 27.0934 6.51984C27.0801 8.59984 25.4401 10.2932 23.3734 10.3598Z",
    fill: "#2F65CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.72 19.6C26.2266 20.6 24.1333 20.9734 22.2 20.72C22.7066 19.6267 22.9733 18.4134 22.9866 17.1334C22.9866 15.8001 22.6933 14.5334 22.1333 13.4267C24.1066 13.16 26.2 13.5334 27.7066 14.5334C29.8133 15.92 29.8133 18.2 27.72 19.6Z",
    fill: "#2F65CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58655 10.3598C8.67988 10.3465 8.77322 10.3465 8.86655 10.3598C10.9332 10.2932 12.5732 8.59984 12.5732 6.51984C12.5732 4.3865 10.8532 2.6665 8.71988 2.6665C6.59988 2.6665 4.87988 4.3865 4.87988 6.51984C4.87988 8.59984 6.51988 10.2932 8.58655 10.3598Z",
    fill: "#2F65CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73325 17.1331C8.73325 18.4265 9.01325 19.6531 9.51991 20.7598C7.63991 20.9598 5.67991 20.5598 4.23991 19.6131C2.13325 18.2131 2.13325 15.9331 4.23991 14.5331C5.66658 13.5731 7.67991 13.1865 9.57325 13.3998C9.02658 14.5198 8.73325 15.7865 8.73325 17.1331Z",
    fill: "#2F65CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1599 21.16C16.0532 21.1467 15.9332 21.1467 15.8132 21.16C13.3599 21.08 11.3999 19.0667 11.3999 16.5867C11.4132 14.0533 13.4532 12 15.9999 12C18.5332 12 20.5866 14.0533 20.5866 16.5867C20.5732 19.0667 18.6266 21.08 16.1599 21.16Z",
    fill: "#2F65CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8267 23.92C9.81332 25.2667 9.81332 27.48 11.8267 28.8134C14.12 30.3467 17.88 30.3467 20.1733 28.8134C22.1867 27.4667 22.1867 25.2534 20.1733 23.92C17.8933 22.3867 14.1333 22.3867 11.8267 23.92Z",
    fill: "#2F65CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople1);
export default __webpack_public_path__ + "static/media/people1.218930702cff639466354e13aca5e54f.svg";
export { ForwardRef as ReactComponent };